// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as Client_assets from "@literacyplanet/client_assets";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as AcademyIcons$LiteracyplanetClientSxEntry from "./AcademyIcons.res.mjs";
import * as WordFlyersTrophies$LiteracyplanetClientSxEntry from "../word_flyers/assets/WordFlyersTrophies.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";

import './parallax.css'
;

var scroll = (function(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

var innerHeight = (function() {
    return window.innerHeight
  });

function AcademyParallax$ScreenWindow(props) {
  var __navigateToWindow = props.navigateToWindow;
  var i = props.i;
  var navigateToWindow = __navigateToWindow !== undefined ? __navigateToWindow : false;
  var domRef = React.useRef(null);
  var isInView = React$1.useInView(domRef, {
        amount: 0.9
      });
  var match = Curry._1(AcademyParallaxTypes$LiteracyplanetClientSxEntry.use, undefined);
  var onActiveCategoryWindowChanged = match.onActiveCategoryWindowChanged;
  React.useEffect((function (param) {
          if (isInView) {
            Curry._1(onActiveCategoryWindowChanged, i);
          }
          
        }), [isInView]);
  React.useEffect((function (param) {
          if (navigateToWindow) {
            scroll(domRef.current);
          }
          
        }), [navigateToWindow]);
  return React.createElement("div", {
              key: String(i),
              ref: Caml_option.some(domRef),
              className: "academy__parallax__screen__window academy__parallax__screen__window-" + String(i)
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge("academy__parallax__screen__window__page", isInView ? "academy__parallax__screen__window__page-active" : "")
                }, props.children));
}

var ScreenWindow = {
  make: AcademyParallax$ScreenWindow
};

function AcademyParallax$Levels(props) {
  var match = Curry._1(AcademyParallaxTypes$LiteracyplanetClientSxEntry.use, undefined);
  var onClickLevel = match.onClickLevel;
  var currentLevel = match.currentLevel;
  return React.createElement("ul", {
              className: "academy__levels"
            }, Belt_Array.mapWithIndex(match.query.levels, (function (i, param) {
                    var levelName = param[1];
                    var level = param[0];
                    return React.createElement("li", {
                                key: levelName,
                                className: TailwindMerge.twMerge("academy__levels__item", currentLevel === level ? "academy__levels__item--active" : "")
                              }, React.createElement("button", {
                                    className: "academy__levels__item__button academy__levels__item__button--" + String(i),
                                    onClick: (function (param) {
                                        Curry._1(onClickLevel, level);
                                      })
                                  }, levelName));
                  })));
}

var Levels = {
  make: AcademyParallax$Levels
};

function AcademyParallax$RenderData(props) {
  var data = props.data;
  var i = props.i;
  var match = Curry._1(AcademyParallaxTypes$LiteracyplanetClientSxEntry.use, undefined);
  var onClickActivity = match.onClickActivity;
  var onClickCategory = match.onClickCategory;
  var query = match.query;
  var tmp;
  var exit = 0;
  if (typeof data !== "object") {
    tmp = null;
  } else {
    switch (data.TAG) {
      case "Strands" :
      case "Categories" :
          exit = 1;
          break;
      case "Activities" :
          tmp = Belt_Array.map(data._0, (function (activity) {
                  var match = activity.score;
                  return React.createElement("div", {
                              key: activity.id,
                              className: "academy__activity__card"
                            }, React.createElement("div", {
                                  className: "academy__activity__card__game__icon"
                                }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.ProgressImageIcon.make, {
                                      imageUrl: Client_assets.primaryActivityIcons.getIcon(activity.kind),
                                      progressState: activity.progressState
                                    })), React.createElement("div", {
                                  className: "academy__activity__card__content"
                                }, React.createElement("h2", {
                                      className: "academy__activity__card__title"
                                    }, activity.title), React.createElement("div", {
                                      className: "academy__activity__card__actions"
                                    }, React.createElement("button", {
                                          className: "academy__activity__card__play",
                                          onClick: (function (param) {
                                              Curry._1(onClickActivity, activity);
                                            })
                                        }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.PlayButton.make, {
                                              className: "academy__activity__card__play-icon"
                                            })), match !== undefined ? React.createElement("div", {
                                            className: "academy__activity__card__progress"
                                          }, React.createElement("span", {
                                                className: "academy__activity__card__progress-dot"
                                              }), React.createElement("span", {
                                                className: "academy__activity__card__progress-text"
                                              }, String(match.accuracy)), React.createElement("div", {
                                                className: "academy__activity__card__trophy"
                                              }, WordFlyersTrophies$LiteracyplanetClientSxEntry.trophyToIcon(match.trophy))) : null)));
                }));
          break;
      
    }
  }
  if (exit === 1) {
    tmp = Belt_Array.map(data._0, (function (category) {
            var subtitle = category.subtitle;
            return JsxPPXReactSupportC.createElementVariadicWithKey(category.id, Motion$LiteracyplanetClientFlags.Button.make, {
                        whileTap: {
                          scale: 0.95
                        },
                        whileHover: {
                          scale: 1.05
                        },
                        className: TailwindMerge.twMerge("academy__menu__card", Belt_Array.some(query.breadcrumb, (function (bc) {
                                    return bc.id === category.id;
                                  })) ? "academy__menu__card-active" : ""),
                        onClick: (function (param) {
                            Curry._2(onClickCategory, category, i);
                          }),
                        children: null
                      }, [
                        React.createElement("div", {
                              className: "academy__menu__card__header"
                            }, React.createElement("h3", {
                                  className: "academy__menu__card__title"
                                }, category.title), React.createElement("div", {
                                  className: "academy__menu__card__accuracy academy__menu__card__accuracy--" + category.accuracy
                                })),
                        subtitle !== undefined ? React.createElement("p", {
                                className: "academy__menu__card__subtitle"
                              }, subtitle) : null,
                        React.createElement("div", {
                              className: "academy__menu__card__progress"
                            }, React.createElement("div", {
                                  className: "academy__menu__card__progress__bar",
                                  style: {
                                    width: String(category.progress) + "%"
                                  }
                                }))
                      ]);
          }));
  }
  return React.createElement("div", {
              className: "academy__menu__grid"
            }, tmp);
}

var RenderData = {
  make: AcademyParallax$RenderData
};

function AcademyParallax$Menu(props) {
  var match = Curry._1(AcademyParallaxTypes$LiteracyplanetClientSxEntry.use, undefined);
  var loadWindow = match.loadWindow;
  var tmp;
  tmp = typeof loadWindow !== "object" || loadWindow.TAG !== "LoadNewWindow" ? null : React.createElement(AcademyParallax$ScreenWindow, {
          id: "",
          i: loadWindow._0,
          navigateToWindow: true,
          children: null
        });
  return React.createElement(React.Fragment, {}, Belt_Array.mapWithIndex(match.query.data, (function (i, data) {
                    if (typeof loadWindow === "object") {
                      switch (loadWindow.TAG) {
                        case "LoadNewWindow" :
                            break;
                        case "ReplaceExistingWindow" :
                            var replaceAt = loadWindow._0;
                            if (replaceAt === i) {
                              return React.createElement(AcademyParallax$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: null
                                        });
                            }
                            if (i > replaceAt) {
                              return null;
                            }
                            break;
                        case "NavigateToWindow" :
                            if (loadWindow._0 === i) {
                              return React.createElement(AcademyParallax$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: React.createElement(AcademyParallax$RenderData, {
                                                i: i,
                                                data: data
                                              })
                                        });
                            }
                            break;
                        
                      }
                    }
                    return React.createElement(AcademyParallax$ScreenWindow, {
                                id: "",
                                i: i,
                                children: React.createElement(AcademyParallax$RenderData, {
                                      i: i,
                                      data: data
                                    })
                              });
                  })), tmp);
}

var Menu = {
  make: AcademyParallax$Menu
};

function AcademyParallax(props) {
  var ref = React.useRef(null);
  var match = React$1.useScroll({
        container: ref
      });
  var scrollYProgress = match.scrollYProgress;
  if (scrollYProgress !== undefined) {
    var match$1 = Curry._1(AcademyParallaxTypes$LiteracyplanetClientSxEntry.use, undefined);
    var onClickBreadcrumb = match$1.onClickBreadcrumb;
    var activeCategoryWindow = match$1.activeCategoryWindow;
    React$1.useSpring(Caml_option.valFromOption(scrollYProgress), {
          stiffness: 100,
          damping: 30,
          restDelta: 0.001
        });
    return React.createElement("div", {
                className: "academy__parallax"
              }, React.createElement("div", {
                    ref: Caml_option.some(ref),
                    className: "academy__parallax__screen"
                  }, React.createElement(AcademyParallax$Menu, {})), React.createElement("div", {
                    className: "academy__parallax__breadcrumb"
                  }, React.createElement("div", {
                        className: "academy__parallax__breadcrumb_strands"
                      }, Belt_Array.mapWithIndex(match$1.query.breadcrumb, (function (i, bc) {
                              return JsxPPXReactSupportC.createElementWithKey(bc.id, Motion$LiteracyplanetClientFlags.Div.make, {
                                          initial: {
                                            scale: 1.0
                                          },
                                          animate: {
                                            scale: activeCategoryWindow === i ? 1.2 : 1.0
                                          },
                                          transition: {
                                            duration: 0.3,
                                            ease: "easeOut"
                                          },
                                          className: TailwindMerge.twMerge("academy__parallax__breadcrumb_links", activeCategoryWindow === i ? "academy__parallax__breadcrumb_links-active" : ""),
                                          onClick: (function (param) {
                                              Curry._1(onClickBreadcrumb, i);
                                            }),
                                          children: Caml_option.some(bc.title)
                                        });
                            })))), React.createElement(AcademyParallax$Levels, {}));
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "AcademyParallax.res",
          263,
          2
        ],
        Error: new Error()
      };
}

var make = AcademyParallax;

export {
  scroll ,
  innerHeight ,
  ScreenWindow ,
  Levels ,
  RenderData ,
  Menu ,
  make ,
}
/*  Not a pure module */
